/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.30/esri/copyright.txt for details.
*/
var N;!function(N){N[N.NONE=0]="NONE",N[N.ANY=1]="ANY",N[N.Z=2]="Z",N[N.XY=4]="XY"}(N||(N={}));export{N as GrabbingState};
